<template>
  <v-card>
    <v-card-title>
      Настройки слоя
    </v-card-title>
    <v-card-text class="pb-0">
      <v-text-field
        v-model="settings.alias"
        :disabled="disableAliasField"
        label="Псевдоним слоя"
      />
    </v-card-text>

    <v-card-text class="py-0">
      <v-checkbox
        v-model="settings.hasMoreMenu"
        label="Наличие фильтр-панели"
        hide-details
      />
      <br>
      <custom-select
        :data="settings.panelSize"
        :list="PANEL_SIZES"
        :disabled="!settings.hasMoreMenu"
        label="Размер панели"
        item-text="text"
        item-value="value"
        source
        hide-details
        @change="onPanelSizeChange"
      />
      <v-checkbox
        v-model="settings.uniqueFilterPanel"
        :disabled="!settings.hasMoreMenu"
        label="Уникальная фильтр-панели"
        hide-details
      />
    </v-card-text>


    <v-card-text class="pb-0">
      <v-checkbox
        v-model="settings.hasLayerButton"
        label="Наличие окна-подсказки (для тайфунов)"
        hide-details
      />
    </v-card-text>

    <v-card-text class="pb-0">
      <v-checkbox
        v-model="settings.deactivateTrigger"
        label="Отключать другие слои с такой же галочкой при включении слоя"
        hide-details
      />
    </v-card-text>

    <div class="mt-2 d-flex pa-5">
      <div class="d-flex flex-grow-1" />
      <v-btn color="primary" @click="onSave">Сохранить</v-btn>
    </div>
  </v-card>
</template>

<script>
import CustomSelect from '@/components/ui/custom-select';

const SMALL_PANEL_SIZE = 'small';
const MEDIUM_PANEL_SIZE = 'medium';
const LARGE_PANEL_SIZE = 'large';

const PANEL_SIZES = [
  {
    text: 'Маленький',
    value: SMALL_PANEL_SIZE,
  },
  {
    text: 'Средний',
    value: MEDIUM_PANEL_SIZE,
  },
  {
    text: 'Большой',
    value: LARGE_PANEL_SIZE,
  },
];

export default {
  name: 'custom-tab',

  components: {
    CustomSelect,
  },

  model: {
    prop: 'propSettings',
    event: 'change',
  },

  props: {
    propSettings: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      PANEL_SIZES,
      disableAliasField: false,
      settings: {
        ...{
          alias: '',
          deactivateTrigger: false,
          hasLayerButton: false,
          hasMoreMenu: false,
          panelSize: SMALL_PANEL_SIZE,
          uniqueFilterPanel: false,
        },
        ...this.propSettings,
      },
    };
  },

  created() {
    this.disableAliasField = !!this.propSettings.alias;
    this.valuesWithoutChange = Object.assign({}, this.settings);
    this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
  },

  methods: {
    beforeLeave() {
      return this.settings;
    },
    onSave() {
      this.valuesWithoutChange = Object.assign({}, this.settings);
      this.$emit('registerGuard', [this.valuesWithoutChange, this.beforeLeave]);
      this.$emit('save', this.settings);
    },

    onPanelSizeChange(size) {
      this.settings.panelSize = size;
    },
  },
};
</script>

<style>

</style>
